import { HTTP } from '@/services/axios';

export async function getContactCategories({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/customMailing/MailingContactCategories/getContactCategories.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getContactCategory({categoryId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customMailing/MailingContactCategories/getContactCategoryData.php?categoryId=${categoryId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function getContactCategoryOptions(){
    let result = [];
    
    await HTTP.get('/app/customMailing/MailingContactCategories/getContactCategoryOptions.php',{})
    .then(response => {
        console.log(response.data)
        result = response.data.result;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}


export async function unlockContactCategory(categoryId){
    let result = {};

    var data = {'categoryId':categoryId}
    
    await HTTP({
        method: 'patch',
        url: '/app/customMailing/MailingContactCategories/controlContactCategoryUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateContactCategory({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/customMailing/MailingContactCategories/controlContactCategoryChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createContactCategory(data){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingContactCategories/controlContactCategorySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveContactCategory(data){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/customMailing/MailingContactCategories/controlContactCategorySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteContactCategory({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/customMailing/MailingContactCategories/controlContactCategoryDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}